import $ from 'jquery';
import Swiper from 'swiper';

(() => {
  const swiperSlides = document.getElementsByClassName('swiper-slide');
  const breakPoint = 769; // ブレークポイントを設定
  let swiper;
  let swiperBool;

  window.addEventListener(
    'load',
    () => {
      if (breakPoint < window.innerWidth) {
        swiperBool = false;
      } else {
        createSwiper();
        swiperBool = true;
      }
    },
    false,
  );

  window.addEventListener(
    'resize',
    () => {
      if (breakPoint < window.innerWidth && swiperBool) {
        swiper.destroy(false, true);
        swiperBool = false;
      } else if (breakPoint >= window.innerWidth && !swiperBool) {
        createSwiper();
        swiperBool = true;
      }
    },
    false,
  );

  const createSwiper = () => {
    swiper = new Swiper('.swiper', {
      // loop: true, // ループさせる
      // centeredSlides:true,
      // speed: 1500, // 少しゆっくり(デフォルトは300)
      // autoplay: {
      //   // 自動再生
      //   delay: 1000, // 1秒後に次のスライド
      //   disableOnInteraction: false, // 矢印をクリックしても自動再生を止めない
      // },
      // // ページネーション
      // pagination: {
      //   el: '.swiper-pagination',
      //   clickable: true, // クリック可能にする
      // },
      // // 前後の矢印
      // navigation: {
      //   nextEl: '.swiper-button-next',
      //   prevEl: '.swiper-button-prev',
      // },
    });
  };
})();
